import { render, staticRenderFns } from "./certificateDialog.vue?vue&type=template&id=b7eb83d4&scoped=true"
import script from "./certificateDialog.vue?vue&type=script&lang=js"
export * from "./certificateDialog.vue?vue&type=script&lang=js"
import style0 from "./certificateDialog.vue?vue&type=style&index=0&id=b7eb83d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eb83d4",
  null
  
)

export default component.exports